<template>
  <div class="post d-flex flex-column-fluid pt-0 bg-lighten">
    <div class="container-xxl p-0" ref="errosGerais">
      <div
        v-if="loading"
        class="ms-7 mb-7 pt-5"
        v-bind:data-kt-indicator="loading ? 'on' : 'off'"
      >
        <span class="indicator-progress">
          Aguarde, carregando...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
      </div>
      <div
        v-if="this.errosGerais.Message"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-7 me-7 mb-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              {{ this.errosGerais.Message }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="this.errosValidacaoGeral.length && !this.loading"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-7 me-7 mb-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              <ul>
                <li v-for="value in this.errosValidacaoGeral" :key="value">
                  {{ value }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="d-flex flex-column flex-lg-row px-7 pt-5">
        <div
          class="d-flex flex-column gap-6 gap-lg-10 w-100 w-lg-300px min-w-sm-300px mb-7 me-lg-10"
        >
          <div class="card card-flush py-4">
            <div class="card-header">
              <div class="card-title">
                <h2>Foto</h2>
              </div>
            </div>
            <div class="card-body text-center pt-0">
              <div
                id="imgFoto"
                class="image-input image-input-outline"
                data-kt-image-input="true"
              >
                <div
                  class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                  v-if="vendedor && vendedor.foto"
                  :style="{ 'background-image': `url(${vendedor.foto})` }"
                ></div>
                <div
                  class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                  v-else
                  :style="{
                    'background-image': `url(media/svg/files/blank-image.svg)`,
                  }"
                ></div>
                <label
                  class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                  data-kt-image-input-action="change"
                  data-bs-toggle="tooltip"
                  data-bs-dismiss="click"
                  title="Alterar foto"
                >
                  <i class="bi bi-pencil-fill fs-7"></i>
                  <input
                    ref="fileInput"
                    type="file"
                    name="avatar"
                    accept=".png, .jpg, .jpeg"
                    @input="pickFile"
                  />
                  <input type="hidden" name="avatar_remove" />
                </label>
                <span
                  class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                  data-kt-image-input-action="remove"
                  data-bs-toggle="tooltip"
                  @click="removerFoto()"
                  data-bs-dismiss="click"
                  title="Remover foto"
                >
                  <i class="bi bi-x fs-2"></i>
                </span>
              </div>
              <div class="form-text mt-6">
                Selecione uma foto. Apenas *.png, *.jpg e *.jpeg aquivo de foto
                é aceito
              </div>
            </div>
          </div>
          <div class="card card-flush py-4">
            <div class="card-header">
              <div class="card-title">
                <h2>Situação</h2>
              </div>
              <div class="card-toolbar">
                <div
                  class="rounded-circle w-15px h-15px"
                  :class="[vendedor.ativo === '1' ? 'bg-success' : 'bg-danger']"
                ></div>
              </div>
            </div>
            <div class="card-body pt-0">
              <select
                class="form-select mb-2"
                data-placeholder="Selecione uma opção"
                v-model="vendedor.ativo"
              >
                <option value="1">Ativo</option>
                <option value="0">Indisponível</option>
              </select>
              <div class="text-muted fs-7">Defina a situação do vendedor</div>
            </div>
          </div>
          <div class="card card-flush py-4">
            <div class="card-header">
              <div class="card-title">
                <h2>Plano de Contas / Centro de Custos</h2>
              </div>
            </div>
            <div class="card-body pt-4">
              <div class="fv-row mb-10">
                <label class="form-label">Conta</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="vendedor.id_conta"
                    readonly
                  />
                  <button
                    class="input-group-text"
                    @click="this.modalContas(true)"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/general/gen004.svg"
                      />
                    </span>
                  </button>
                </div>
              </div>
              <div class="fv-row mb-4">
                <label class="form-label">Custo</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="vendedor.id_custo"
                    readonly
                  />
                  <button
                    class="input-group-text"
                    @click="this.modalCustos(true)"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/general/gen004.svg"
                      />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column flex-row-fluid gap-6 mb-7 gap-lg-10">
          <ul
            class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-n2"
          >
            <li class="nav-item">
              <a
                ref="tabGeral"
                class="nav-link text-active-primary pb-4 active"
                data-bs-toggle="tab"
                href="#kt_vendedor_geral"
                >Geral</a
              >
            </li>
            <li v-if="this.consultarVendedorEndereco" class="nav-item">
              <a
                ref="tabEnderecos"
                class="nav-link text-active-primary pb-4"
                data-bs-toggle="tab"
                href="#kt_vendedor_enderecos"
                >Endereços</a
              >
            </li>
            <li v-if="this.consultarVendedorTelefone" class="nav-item">
              <a
                ref="tabTelefones"
                class="nav-link text-active-primary pb-4"
                data-bs-toggle="tab"
                href="#kt_vendedor_telefones"
                >Telefones</a
              >
            </li>
            <li v-if="this.consultarVendedorEmail" class="nav-item">
              <a
                ref="tabEmails"
                class="nav-link text-active-primary pb-4"
                data-bs-toggle="tab"
                href="#kt_vendedor_emails"
                >Emails</a
              >
            </li>
            <li class="nav-item">
              <a
                ref="tabAdicionais"
                class="nav-link text-active-primary pb-4"
                data-bs-toggle="tab"
                href="#kt_vendedor_adicionais"
                >Adicionais</a
              >
            </li>
            <li class="nav-item">
              <a
                ref="tabObservacoes"
                class="nav-link text-active-primary pb-4"
                data-bs-toggle="tab"
                href="#kt_vendedor_observacoes"
                >Observações</a
              >
            </li>
          </ul>
          <div class="tab-content">
            <div
              class="tab-pane fade show active"
              id="kt_vendedor_geral"
              role="tab-panel"
            >
              <div class="d-flex flex-column gap-7 gap-lg-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title">
                      <h2>Geral</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label for="txtNome" class="required form-label"
                            >Nome do vendedor</label
                          >
                          <input
                            type="text"
                            id="txtNome"
                            :value="
                              (vendedor.nome = vendedor.nome.toUpperCase())
                            "
                            @input="
                              vendedor.nome = $event.target.value.toUpperCase()
                            "
                            class="form-control"
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["nome"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label for="txtFantasia" class="form-label"
                            >Fantasia</label
                          >
                          <input
                            type="text"
                            id="txtFantasia"
                            class="form-control"
                            :value="
                              (vendedor.fantasia = vendedor.fantasia
                                ? vendedor.fantasia.toUpperCase()
                                : '')
                            "
                            @input="
                              vendedor.fantasia =
                                $event.target.value.toUpperCase()
                            "
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["fantasia"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-7 col-xxl-7 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label for="txtCPFCNPJ" class="required form-label"
                            >CPF / CNPJ</label
                          >
                          <div class="input-group">
                            <input
                              type="text"
                              id="txtCPFCNPJ"
                              class="form-control"
                              v-mask="['###.###.###-##', '##.###.###/####-##']"
                              v-model="vendedor.cpf_cnpj"
                            />
                            <button
                              @click.prevent="pesquisarCNPJ()"
                              class="input-group-text"
                              v-bind:data-kt-indicator="
                                loadingCNPJ ? 'on' : 'off'
                              "
                            >
                              <span
                                class="svg-icon svg-icon-2"
                                v-if="!loadingCNPJ"
                              >
                                <inline-svg
                                  src="media/icons/duotune/general/gen004.svg"
                                />
                              </span>
                              <span class="indicator-progress">
                                <span
                                  class="spinner-border align-middle"
                                  style="width: 1.5rem; height: 1.5rem"
                                ></span>
                              </span>
                            </button>
                          </div>

                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["cpf_cnpj"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xxl-5 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label for="txtRGIE" class="form-label"
                            >RG / IE</label
                          >
                          <input
                            type="text"
                            id="txtRGIE"
                            class="form-control"
                            v-model="vendedor.rg_ie"
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["rg_ie"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title">
                      <h2>Comissão</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label class="form-label"
                            >Calcular Comissão sobre</label
                          >
                          <select
                            class="form-select mb-2"
                            data-placeholder="Selecione uma opção"
                            id="spComissaoSobre"
                            v-model="vendedor.comissao_sobre"
                            @change="verificaRegra($event.target.value)"
                          >
                            <option value="0">Total da Nota</option>
                            <option value="1">Produtos</option>
                            <option value="2">Total de Produtos da Nota</option>
                            <option value="3">Regra</option>
                            <option value="4">Regra Produto</option>
                          </select>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["comissao_sobre"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label class="form-label"
                            >Recebimento Comissão?</label
                          >
                          <select
                            class="form-select mb-2"
                            data-placeholder="Selecione uma opção"
                            id="spRecebimentoComissao"
                            v-model="vendedor.recebimento_comissao"
                          >
                            <option value="0">Emissão da nota</option>
                            <option value="1">Ao receber parcela</option>
                            <option value="2">Dia fixo</option>
                          </select>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["recebimento_comissao"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 mb-4"
                      >
                        <div class="mb-5 fv-row">
                          <label class="form-label">% Comissão</label>
                          <CurrencyInput
                            class="form-control mb-2"
                            placeholder="% Comissão"
                            style="text-align: right"
                            v-model="vendedor.comissao"
                            :options="options"
                          ></CurrencyInput>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["comissao"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <div class="col-auto fv-row mb-4">
                            <label class="form-label">Dia Acerto</label>
                            <div class="col">
                              <el-input-number
                                id="txtDiaAcerto"
                                v-model="vendedor.dia_acerto"
                                class="w-150px"
                                :min="1"
                                :max="31"
                                size="large"
                                controls-position="right"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 mb-4"
                      >
                        <div class="mb-5 fv-row">
                          <label class="form-label">% Desconto</label>
                          <CurrencyInput
                            class="form-control mb-2"
                            placeholder="% Desconto"
                            style="text-align: right"
                            v-model="vendedor.per_desconto"
                            :options="options"
                          ></CurrencyInput>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["per_desconto"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 mb-4"
                      >
                        <div class="mb-10 fv-row">
                          <label class="form-label">% Adiantamento</label>
                          <CurrencyInput
                            class="form-control mb-2"
                            placeholder="% Adiantamento"
                            style="text-align: right"
                            v-model="vendedor.percentual_adiantamento"
                            :options="options"
                          ></CurrencyInput>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["percentual_adiantamento"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row"
                      v-if="this.vendedor.comissao_sobre === '3'"
                    >
                      <el-divider class="col-8 mb-14" content-position="left"
                        >Regras de Comissão
                      </el-divider>
                      <el-divider class="col-4 mb-14" content-position="right">
                        <button
                          @click="adicionarRegraComissaoVendedor()"
                          class="col-auto btn btn-sm btn-primary m-0 p-2"
                        >
                          <span class="svg-icon svg-icon-1 m-0 p-0">
                            <inline-svg
                              src="media/icons/duotune/general/gen041.svg"
                          /></span></button
                      ></el-divider>
                      <div class="col-12 mb-4">
                        <div class="mb-5 fv-row">
                          <Datatable
                            v-if="
                              this.vendedor.RegraComissaoVendedor.length > 0
                            "
                            :table-header="
                              this.tableRegraComissaoVendedorHeader
                            "
                            :table-data="this.vendedor.RegraComissaoVendedor"
                            :rowsPerPage="1000"
                            :loading="this.loadingRegraComissao"
                            :enableItemsPerPageDropdown="false"
                          >
                            <template
                              v-slot:cell-valor_venda="{
                                row: regraComissaoVendedor,
                              }"
                            >
                              <div class="">
                                {{
                                  this.$utils.formatarNumero(
                                    regraComissaoVendedor.valor_venda
                                  )
                                }}
                              </div>
                            </template>
                            <template
                              v-slot:cell-per_comissao="{
                                row: regraComissaoVendedor,
                              }"
                            >
                              <div class="">
                                {{
                                  this.$utils.formatarNumero(
                                    regraComissaoVendedor.per_comissao
                                  )
                                }}
                              </div>
                            </template>
                            <template v-slot:cell-acoes="{ position: index }">
                              <div>
                                <button
                                  class="btn btn-sm btn-light btn-active-light-primary"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                  data-kt-menu-flip="top-end"
                                  tabindex="-1"
                                >
                                  Ações
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/arrows/arr072.svg"
                                    />
                                  </span>
                                </button>
                                <div
                                  class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                                  data-kt-menu="true"
                                >
                                  <div class="menu-item px-3">
                                    <a
                                      @click="
                                        editarRegraComissaoVendedor(index)
                                      "
                                      class="menu-link px-3"
                                      >Editar</a
                                    >
                                  </div>
                                  <div class="menu-item px-3">
                                    <a
                                      @click="
                                        removerRegraComissaoVendedor(index)
                                      "
                                      class="menu-link px-3"
                                      >Excluír</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </template>
                          </Datatable>
                          <template v-else>
                            <table
                              class="table align-middle table-row-dashed fs-6 gy-5 gs-7 text-gray-600 fw-bold dataTable no-footer table-hover"
                            >
                              <tbody>
                                <tr class="odd">
                                  <td :colSpan="12" class="dataTables_empty">
                                    {{ "Nenhuma regra foi adicionada" }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="kt_vendedor_enderecos"
              role="tab-panel"
            >
              <div class="d-flex flex-column gap-7 gap-lg-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title" ref="vendedor_endereco">
                      <h2>Endereços</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div
                      v-if="this.errosGeraisEndereco.Message"
                      class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
                    >
                      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                        <inline-svg
                          src="media/icons/duotune/general/gen044.svg"
                        />
                      </span>
                      <div class="d-flex flex-stack flex-grow-1">
                        <div class="fw-bold">
                          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                          <div class="fs-6 text-gray-600">
                            {{ this.errosGeraisEndereco.Message }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mb-6"
                      v-for="(endereco, i) in this.vendedor.VendedorEndereco"
                      v-bind:key="i"
                    >
                      <div
                        v-if="i != 0"
                        class="separator border-2 separator-dashed border-gray-300 mb-10"
                      ></div>
                      <div class="col-xl-6 col-xxl-4 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">Descrição</label>
                        <select
                          class="form-select"
                          v-model="endereco.descricao"
                          :disabled="
                            this.add === false &&
                            this.editarVendedorEndereco === false
                          "
                        >
                          <option value="Casa">Casa</option>
                          <option value="Trabalho">Trabalho</option>
                          <option value="Comercial">Comercial</option>
                          <option value="Outro">Outro</option>
                        </select>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "VendedorEndereco[" + i + "]descricao"
                            ]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["descricao"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xl-6 col-xxl-4 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">CEP</label>
                        <div class="input-group">
                          <input
                            type="text"
                            @keydown.stop.prevent.enter="pesquisarCep(i)"
                            class="form-control"
                            v-mask="'#####-###'"
                            v-model="endereco.cep"
                            :disabled="
                              this.add === false &&
                              this.editarVendedorEndereco === false
                            "
                          />
                          <button
                            @click="pesquisarCep(i)"
                            class="input-group-text"
                            v-bind:data-kt-indicator="loadingCep ? 'on' : 'off'"
                          >
                            <span
                              class="svg-icon svg-icon-2"
                              v-if="!loadingCep"
                            >
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                            <span class="indicator-progress">
                              <span
                                class="spinner-border align-middle"
                                style="width: 1.5rem; height: 1.5rem"
                              ></span>
                            </span>
                          </button>
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ errosValidacao["VendedorEndereco[" + i + "]cep"] }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["cep"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-8 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">Endereço</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="endereco.endereco"
                          :disabled="
                            this.add === false &&
                            this.editarVendedorEndereco === false
                          "
                        />
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "VendedorEndereco[" + i + "]endereco"
                            ]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["endereco"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xl-5 col-xxl-4 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">Número</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="endereco.numero"
                          :disabled="
                            this.add === false &&
                            this.editarVendedorEndereco === false
                          "
                        />
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao["VendedorEndereco[" + i + "]numero"]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["numero"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xl-7 col-xxl-6 fv-row mb-6">
                        <label class="form-label fw-bold fs-6"
                          >Complemento</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-model="endereco.complemento"
                          :disabled="
                            this.add === false &&
                            this.editarVendedorEndereco === false
                          "
                        />
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "VendedorEndereco[" + i + "]complemento"
                            ]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["complemento"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-6 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">Bairro</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="endereco.bairro"
                          :disabled="
                            this.add === false &&
                            this.editarVendedorEndereco === false
                          "
                        />
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao["VendedorEndereco[" + i + "]bairro"]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["bairro"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-4 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">UF</label>
                        <select
                          class="form-select"
                          v-model="endereco.uf"
                          :disabled="
                            this.add === false &&
                            this.editarVendedorEndereco === false
                          "
                        >
                          <option value="AC">Acre</option>
                          <option value="AL">Alagoas</option>
                          <option value="AP">Amapá</option>
                          <option value="AM">Amazonas</option>
                          <option value="BA">Bahia</option>
                          <option value="CE">Ceara</option>
                          <option value="DF">Distrito Federal</option>
                          <option value="ES">Espirito Santo</option>
                          <option value="GO">Goiás</option>
                          <option value="MA">Maranhão</option>
                          <option value="MT">Mato Grosso</option>
                          <option value="MS">Mato Grosso do Sul</option>
                          <option value="MG">Minas Gerais</option>
                          <option value="PA">Para</option>
                          <option value="PB">Paraíba</option>
                          <option value="PR">Paraná</option>
                          <option value="PE">Pernambuco</option>
                          <option value="PI">Piauí</option>
                          <option value="RJ">Rio de Janeiro</option>
                          <option value="RN">Rio Grande do Norte</option>
                          <option value="RS">Rio Grande do Sul</option>
                          <option value="RO">Rondônia</option>
                          <option value="RR">Roraima</option>
                          <option value="SC">Santa Catarina</option>
                          <option value="SP">São Paulo</option>
                          <option value="SE">Sergipe</option>
                          <option value="TO">Tocantins</option>
                        </select>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ errosValidacao["VendedorEndereco[" + i + "]uf"] }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["uf"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-5 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">Cidade</label>
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control"
                            :value="
                              endereco.cidade
                                ? endereco.cidade.toUpperCase()
                                : ''
                            "
                            @input="
                              endereco.cidade =
                                $event.target.value.toUpperCase()
                            "
                            :disabled="
                              this.add === false &&
                              this.editarVendedorEndereco === false
                            "
                          />
                          <button
                            class="input-group-text"
                            @click="exibirModalCidades(true, i)"
                          >
                            <span class="svg-icon svg-icon-2">
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao["VendedorEndereco[" + i + "]cidade"]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["cidade"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-3 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">País</label>
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control"
                            :value="
                              endereco.pais ? endereco.pais.toUpperCase() : ''
                            "
                            @input="
                              endereco.pais = $event.target.value.toUpperCase()
                            "
                            :disabled="
                              this.add === false &&
                              this.editarVendedorEndereco === false
                            "
                          />
                          <button
                            class="input-group-text"
                            @click="exibirModalPaises(true, i)"
                          >
                            <span class="svg-icon svg-icon-2">
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao["VendedorEndereco[" + i + "]pais"]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["pais"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xl-6 col-xxl-3 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">Latitude</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="endereco.latitude"
                          :disabled="
                            this.add === false &&
                            this.editarVendedorEndereco === false
                          "
                        />
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "VendedorEndereco[" + i + "]latitude"
                            ]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["latitude"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xl-6 col-xxl-3 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">Longitude</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="endereco.longitude"
                          :disabled="
                            this.add === false &&
                            this.editarVendedorEndereco === false
                          "
                        />
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "VendedorEndereco[" + i + "]longitude"
                            ]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["longitude"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-4 fv-row mb-6 mt-xxl-8">
                        <button
                          v-if="this.excluirVendedorEndereco"
                          @click="excluirEndereco(i)"
                          class="btn btn-light-danger svg-icon-white me-2 mb-2"
                        >
                          <i class="la la-trash-o me-2 fs-3"></i>Excluír
                        </button>
                      </div>
                    </div>
                    <div class="form-group mt-5 mb-10">
                      <button
                        v-if="this.adicionarVendedorEndereco"
                        @click="adicionarEndereco()"
                        class="btn btn-light-primary"
                      >
                        <i class="la la-plus me-2 fs-3"></i>Adicionar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="kt_vendedor_telefones"
              role="tab-panel"
            >
              <div class="d-flex flex-column gap-7 gap-lg-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title" ref="vendedor_telefone">
                      <h2>Telefones</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div
                      v-if="this.errosGeraisTelefone.Message"
                      class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
                    >
                      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                        <inline-svg
                          src="media/icons/duotune/general/gen044.svg"
                        />
                      </span>
                      <div class="d-flex flex-stack flex-grow-1">
                        <div class="fw-bold">
                          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                          <div class="fs-6 text-gray-600">
                            {{ this.errosGeraisTelefone.Message }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mb-6"
                      v-for="(telefone, i) in this.vendedor.VendedorTelefone"
                      v-bind:key="i"
                    >
                      <div class="col-xl-5 col-xxl-4 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">Descrição</label>
                        <select
                          class="form-select"
                          v-model="telefone.descricao"
                          :disabled="
                            this.add === false &&
                            this.editarVendedorTelefone === false
                          "
                        >
                          <option value="Celular">Celular</option>
                          <option value="Telefone">Telefone</option>
                          <option value="Casa">Casa</option>
                          <option value="Comercial">Comercial</option>
                          <option value="Fax Residencial">
                            Fax Residencial
                          </option>
                          <option value="Fax Comercial">Fax Comercial</option>
                          <option value="Outro">Outro</option>
                        </select>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "VendedorTelefone[" + i + "]descricao"
                            ]
                          }}
                          {{
                            errosValidacaoTelefone[i]
                              ? errosValidacaoTelefone[i]["descricao"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xl-7 col-xxl-5 fv-row mb-6">
                        <label for="txtTelefone" class="form-label"
                          >Número</label
                        >
                        <div class="input-group">
                          <span class="input-group-text" id="basic-addon3">
                            <i class="bi bi-telephone fs-3"></i>
                          </span>
                          <input
                            type="text"
                            id="txtTelefone"
                            class="form-control"
                            v-mask="['(##) ####-####', '(##) #####-####']"
                            v-model="telefone.telefone"
                            :disabled="
                              this.add === false &&
                              this.editarVendedorTelefone === false
                            "
                          />
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "VendedorTelefone[" + i + "]telefone"
                            ]
                          }}
                          {{
                            errosValidacaoTelefone[i]
                              ? errosValidacaoTelefone[i]["telefone"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-3 fv-row mb-6 mt-xxl-8">
                        <button
                          v-if="this.excluirVendedorTelefone"
                          @click="excluirTelefone(i)"
                          class="btn btn-light-danger svg-icon-white me-2 mb-2"
                        >
                          <i class="la la-trash-o me-2 fs-3"></i>Excluír
                        </button>
                      </div>
                    </div>
                    <div class="form-group mt-5 mb-10">
                      <button
                        v-if="this.adicionarVendedorTelefone"
                        @click="adicionarTelefone()"
                        class="btn btn-light-primary"
                      >
                        <i class="la la-plus me-2 fs-3"></i>Adicionar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="kt_vendedor_emails" role="tab-panel">
              <div class="d-flex flex-column gap-7 gap-lg-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title" ref="vendedor_email">
                      <h2>Emails</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div
                      v-if="this.errosGeraisEmail.Message"
                      class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
                    >
                      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                        <inline-svg
                          src="media/icons/duotune/general/gen044.svg"
                        />
                      </span>
                      <div class="d-flex flex-stack flex-grow-1">
                        <div class="fw-bold">
                          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                          <div class="fs-6 text-gray-600">
                            {{ this.errosGeraisEmail.Message }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mb-6"
                      v-for="(email, i) in this.vendedor.VendedorEmail"
                      v-bind:key="i"
                    >
                      <div class="col-xl-5 col-xxl-4 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">Descrição</label>
                        <select
                          class="form-select"
                          v-model="email.descricao"
                          :disabled="
                            this.add === false &&
                            this.editarVendedorEmail === false
                          "
                        >
                          <option value="Pessoal">Pessoal</option>
                          <option value="Cobrança">Cobrança</option>
                          <option value="Comercial">Comercial</option>
                          <option value="Outros">Outros</option>
                        </select>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao["VendedorEmail[" + i + "]descricao"]
                          }}
                          {{
                            errosValidacaoEmail[i]
                              ? errosValidacaoEmail[i]["descricao"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xl-7 col-xxl-5 fv-row mb-6">
                        <label for="txtEmail" class="form-label">Email</label>
                        <div class="input-group">
                          <span class="input-group-text" id="basic-addon3">
                            <i class="bi bi-at fs-3"></i>
                          </span>
                          <input
                            type="text"
                            id="txtEmail"
                            class="form-control"
                            v-model="email.email"
                            :disabled="
                              this.add === false &&
                              this.editarVendedorEmail === false
                            "
                          />
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ errosValidacao["VendedorEmail[" + i + "]email"] }}
                          {{
                            errosValidacaoEmail[i]
                              ? errosValidacaoEmail[i]["email"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-3 fv-row mb-6 mt-xxl-8">
                        <button
                          v-if="this.excluirVendedorEmail"
                          @click="excluirEmail(i)"
                          class="btn btn-light-danger svg-icon-white me-2 mb-2"
                        >
                          <i class="la la-trash-o me-2 fs-3"></i>Excluír
                        </button>
                      </div>
                    </div>
                    <div class="form-group mt-5 mb-10">
                      <button
                        v-if="this.adicionarVendedorEmail"
                        @click="adicionarEmail()"
                        class="btn btn-light-primary"
                      >
                        <i class="la la-plus me-2 fs-3"></i>Adicionar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="kt_vendedor_adicionais"
              role="tab-panel"
            >
              <div class="d-flex flex-column gap-7 gap-lg-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title">
                      <h2>Adicionais</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label class="form-label">Nome do banco</label>
                          <input
                            type="text"
                            class="form-control mb-2"
                            v-model="vendedor.nome_banco"
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["nome_banco"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label class="form-label">Favorecido</label>
                          <input
                            type="text"
                            class="form-control mb-2"
                            v-model="vendedor.favorecido"
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["favorecido"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xxl-4 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label class="form-label">Banco</label>
                          <input
                            type="text"
                            class="form-control mb-2"
                            v-model="vendedor.banco"
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["banco"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xxl-3 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label class="form-label">Conta</label>
                          <input
                            type="text"
                            class="form-control mb-2"
                            v-model="vendedor.conta"
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["conta"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-2 col-xxl-1 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label class="form-label">Dígito</label>
                          <input
                            type="text"
                            maxlength="1"
                            class="form-control mb-2"
                            v-model="vendedor.dv_conta"
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["dv_conta"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xxl-3 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label class="form-label">Agência</label>
                          <input
                            type="text"
                            class="form-control mb-2"
                            v-model="vendedor.agencia"
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["agencia"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-2 col-xxl-1 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label class="form-label">Dígito</label>
                          <input
                            type="text"
                            maxlength="1"
                            class="form-control mb-2"
                            v-model="vendedor.dv_agencia"
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["dv_agencia"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="kt_vendedor_observacoes"
              role="tab-panel"
            >
              <div class="d-flex flex-column gap-7 gap-lg-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title">
                      <h2>Observações</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div class="mb-5 fv-row">
                      <label class="form-label">Observações</label>
                      <textarea
                        id="txtObservacoes"
                        class="form-control mb-2"
                        placeholder="Observações do vendedor"
                        maxlength="500"
                        style="height: 250px"
                        v-model="vendedor.observacoes"
                      />
                      <div class="row">
                        <div class="col-6 pe-0">
                          <div
                            class="fv-plugins-message-container invalid-feedback m-0"
                          >
                            {{ errosValidacao["observacoes"] }}
                          </div>
                        </div>
                        <div class="col-6 ps-2">
                          <div class="text-end text-muted fs-7">
                            {{
                              vendedor.observacoes
                                ? vendedor.observacoes.length
                                : "0"
                            }}/500 caracteres
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button
              v-if="this.modal === true"
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="$emit('cancelarVendedor', false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
            <router-link
              v-else
              to="/cadastros/vendedores/consultar"
              class="btn btn-danger svg-icon-white me-2 mb-2"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </router-link>
            <button
              class="btn btn-success svg-icon-white mb-2"
              @click="confirmarVendedor()"
              v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
            >
              <span class="indicator-progress">
                <span
                  class="spinner-border spinner-border-sm align-middle ms-1"
                ></span>
                Aguarde...
              </span>
              <span class="svg-icon svg-icon-1" v-if="!this.loading">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Confirmar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CidadesModal
    v-if="exibirCidades"
    @exibirModalCidades="modalCidades"
    @confirmarCidade="confirmarCidade"
  ></CidadesModal>
  <PaisesModal
    v-if="exibirPaises"
    @exibirModalPaises="modalPaises"
    @confirmarPais="confirmarPais"
  ></PaisesModal>
  <ContasModal
    v-if="exibirContas"
    @exibirModalContas="modalContas"
    @selecionarConta="selecionarConta"
  ></ContasModal>
  <CustosModal
    v-if="exibirCustos"
    @exibirModalCustos="modalCustos"
    @selecionarCusto="selecionarCusto"
  ></CustosModal>
  <div
    v-if="exibirEditarRegraComissaoVendedor"
    ref="kt_modal_regra_comissao_vendedor"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_regra_comissao_vendedor"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen055.svg" />
            </span>
            <h3
              v-if="this.regraComissao.index === -1"
              class="fw-bold m-0 text-gray-800"
            >
              Adicionar regra de comissão
            </h3>
            <h3 v-else class="fw-bold m-0 text-gray-800">
              Editar regra de comissão
            </h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.modalEditarRegraComissaoVendedor(false)"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body pt-10 pb-0 px-10">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-4">
              <div class="mb-5 fv-row">
                <label class="form-label"
                  >Valor da venda (maior ou igual)</label
                >
                <CurrencyInput
                  id="txtValorVenda"
                  class="form-control mb-2"
                  placeholder="Valor da venda"
                  style="text-align: right"
                  v-model="this.regraComissao.valor_venda"
                  :options="options"
                  @focus="onFocus($event.target.id)"
                  @keydown.stop.prevent.enter="nextFocus(`txtComissao`)"
                ></CurrencyInput>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-4">
              <div class="mb-10 fv-row">
                <label class="form-label">% Comissão</label>
                <CurrencyInput
                  id="txtComissao"
                  class="form-control mb-2"
                  placeholder="% Comissão"
                  style="text-align: right"
                  v-model="this.regraComissao.per_comissao"
                  :options="options"
                  @focus="onFocus($event.target.id)"
                  @keydown.stop.prevent.enter="nextFocus(`btnConfirmarRegra`)"
                ></CurrencyInput>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="this.modalEditarRegraComissaoVendedor(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            id="btnConfirmarRegra"
            type="button"
            class="btn btn-success svg-icon-white mb-2"
            data-bs-dismiss="modal"
            @click="confirmarRegraComissaoVendedor()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MenuComponent } from "@/assets/ts/components";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import CidadesModal from "@/views/cidades/CidadesModal.vue";
import PaisesModal from "@/views/paises/PaisesModal";
import ContasModal from "@/views/contas/ContasModal.vue";
import CustosModal from "@/views/custos/CustosModal.vue";
import { hideModal, getOrCreateInstanceModal } from "@/core/helpers/dom";
import CurrencyInput from "@/components/text/CurrencyInput";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  emits: ["cancelarVendedor", "confirmarVendedor"],
  components: {
    CidadesModal,
    PaisesModal,
    CurrencyInput,
    ContasModal,
    CustosModal,
    Datatable,
  },
  props: {
    idVendedor: { type: Number, required: false, default: 0 },
    modal: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    verificaRegra(regra) {
      if (regra === "3") {
        setTimeout(MenuComponent.reinitialization, 500);
      }
    },
    onFocus(id) {
      document.getElementById(id).select();
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    modalEditarRegraComissaoVendedor(exibir) {
      this.exibirEditarRegraComissaoVendedor = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_regra_comissao_vendedor",
          /*open*/ () => {
            this.$utils.requestFocus("txtValorVenda");
          },
          /*close*/ () => {
            this.modalEditarRegraComissaoVendedor(false);
          }
        );
      }
    },
    adicionarRegraComissaoVendedor() {
      this.regraComissao.index = -1;
      this.regraComissao.id = 0;
      this.regraComissao.id_vendedor = 0;
      this.regraComissao.valor_venda = 0;
      this.regraComissao.per_comissao = 0;
      this.modalEditarRegraComissaoVendedor(true);
    },
    editarRegraComissaoVendedor(index) {
      this.regraComissao.index = index;
      this.regraComissao.id = this.vendedor.RegraComissaoVendedor[index].id;
      this.regraComissao.id_vendedor =
        this.vendedor.RegraComissaoVendedor[index].id_vendedor;
      this.regraComissao.valor_venda =
        this.vendedor.RegraComissaoVendedor[index].valor_venda;
      this.regraComissao.per_comissao =
        this.vendedor.RegraComissaoVendedor[index].per_comissao;
      this.modalEditarRegraComissaoVendedor(true);
    },
    confirmarRegraComissaoVendedor() {
      this.loadingRegraComissao = true;
      var index = this.regraComissao.index;
      if (index === -1) {
        this.vendedor.RegraComissaoVendedor.push({
          id: this.regraComissao.id,
          id_vendedor: this.regraComissao.id_vendedor,
          valor_venda: this.regraComissao.valor_venda,
          per_comissao: this.regraComissao.per_comissao,
        });
      } else {
        this.vendedor.RegraComissaoVendedor[index].id = this.regraComissao.id;
        this.vendedor.RegraComissaoVendedor[index].id_vendedor =
          this.regraComissao.id_vendedor;
        this.vendedor.RegraComissaoVendedor[index].valor_venda =
          this.regraComissao.valor_venda;
        this.vendedor.RegraComissaoVendedor[index].per_comissao =
          this.regraComissao.per_comissao;
      }
      setTimeout(MenuComponent.reinitialization, 500);
      this.modalEditarRegraComissaoVendedor(false);
      this.loadingRegraComissao = false;
    },
    async removerRegraComissaoVendedor(index) {
      await this.$swal.showQuestionAlert(
        "Deseja remover o registro?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.loadingRegraComissao = true;
            this.errosGerais = {};

            var id = this.vendedor.RegraComissaoVendedor[index].id;
            if (id === 0) {
              this.vendedor.RegraComissaoVendedor.splice(index, 1);
              toast.success("Regra excluída com sucesso!", { timeout: 3000 });
            } else {
              try {
                var ret = await this.$store.dispatch(
                  "regraComissaoVendedor/deleteRegraComissaoVendedor",
                  id
                );
                if (ret.Success === true) {
                  this.vendedor.RegraComissaoVendedor.splice(index, 1);
                  toast.success("Regra excluída com sucesso!", {
                    timeout: 3000,
                  });
                }
              } catch (error) {
                this.errosGerais = error;
              }
            }
            this.loadingRegraComissao = false;
          }
        }
      );
    },
    selecionarCusto(custo) {
      this.vendedor.id_custo = custo.id;
    },
    modalCustos(exibir) {
      this.exibirCustos = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_custos_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarCustos");
          },
          /*close*/ () => {
            this.modalCustos(false);
          }
        );
      }
    },
    selecionarConta(conta) {
      this.vendedor.id_conta = conta.id;
    },
    modalContas(exibir) {
      this.exibirContas = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_contas_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarContas");
          },
          /*close*/ () => {
            this.modalContas(false);
          }
        );
      }
    },
    async confirmarVendedor() {
      this.errosGerais = {};
      this.errosValidacao = [];
      this.errosValidacaoGeral = [];
      this.errosGeraisTelefone = {};
      this.errosValidacaoTelefone = [];
      this.errosGeraisEndereco = {};
      this.errosValidacaoEndereco = [];
      this.errosGeraisEmail = {};
      this.errosValidacaoEmail = [];
      this.loading = true;
      this.confirmouCadastro = true;

      this.vendedor.cpf_cnpj =
        this.vendedor.cpf_cnpj === null
          ? ""
          : this.$utils.unMask(this.vendedor.cpf_cnpj);
      this.vendedor.rg_ie =
        this.vendedor.rg_ie === null
          ? ""
          : this.$utils.unMask(this.vendedor.rg_ie);

      this.vendedor.foto =
        this.vendedor.foto === null
          ? ""
          : this.vendedor.foto.replace(this.$utils.getUrl(), "");

      if (this.vendedor.id === 0) {
        this.vendedor.guid = this.$utils.generateUuidv4();
      }

      var formData = this.$utils.convertModelToFormData(this.vendedor);
      if (this.vendedor.id === 0) {
        try {
          var ret = await this.$store.dispatch(
            "vendedor/postVendedor",
            formData
          );
          if (ret.Success === true) {
            this.vendedor.id = ret.Data.id;
            await this.confirmarEndereco();
            await this.confirmarTelefone();
            await this.confirmarEmail();
            await this.confirmarRegraComissao();
          }
        } catch (error) {
          this.errosValidacaoGeral.push(
            ...this.$utils.retornarValoresJson(error)
          );
          this.errosGerais = error;
          this.errosValidacao = error;
          this.confirmouCadastro = false;
        }
      } else {
        try {
          var retPut = await this.$store.dispatch(
            "vendedor/putVendedor",
            formData
          );
          if (retPut.Success === true) {
            await this.confirmarEndereco();
            await this.confirmarTelefone();
            await this.confirmarEmail();
            await this.confirmarRegraComissao();
          }
        } catch (error) {
          this.errosValidacaoGeral.push(
            ...this.$utils.retornarValoresJson(error)
          );
          this.errosGerais = error;
          this.errosValidacao = error;
          this.confirmouCadastro = false;
        }
      }

      if (this.vendedor.foto !== "" && !this.vendedor.foto.includes("base64")) {
        this.vendedor.foto = this.$utils.getUrl() + this.vendedor.foto;
      }

      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }

      this.loading = false;

      if (this.confirmouCadastro === true) {
        toast.success("Cadastro salvo com sucesso!", { timeout: 3000 });
        if (this.modal === true) {
          this.$emit("confirmarVendedor");
        } else {
          this.$router.push("/cadastros/vendedores/consultar");
        }
      } else {
        toast.error("Ocorreu uma falha ao gravar o cadastro, verifique!", {
          timeout: 5000,
        });
      }
    },
    async confirmarEndereco() {
      this.errosValidacaoEndereco = new Array(
        this.vendedor.VendedorEndereco.length
      );
      for (var i = 0; i < this.vendedor.VendedorEndereco.length; i++) {
        if (this.vendedor.VendedorEndereco[i].id === 0) {
          this.vendedor.VendedorEndereco[i].id_vendedor = this.vendedor.id;
          try {
            var ret = await this.$store.dispatch(
              "vendedorEndereco/postVendedorEndereco",
              this.vendedor.VendedorEndereco[i]
            );
            if (ret.Success === true) {
              this.vendedor.VendedorEndereco[i].id = ret.Data.id;
            }
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJson(error)
            );
            this.errosGerais = error;
            this.errosValidacaoEndereco[i] = error;
            this.confirmouCadastro = false;
          }
        } else {
          try {
            await this.$store.dispatch(
              "vendedorEndereco/putVendedorEndereco",
              this.vendedor.VendedorEndereco[i]
            );
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJson(error)
            );
            this.errosGerais = error;
            this.errosValidacaoEndereco[i] = error;
            this.confirmouCadastro = false;
          }
        }
      }
    },
    async confirmarTelefone() {
      this.errosValidacaoTelefone = new Array(
        this.vendedor.VendedorTelefone.length
      );
      for (var i = 0; i < this.vendedor.VendedorTelefone.length; i++) {
        if (this.vendedor.VendedorTelefone[i].id === 0) {
          this.vendedor.VendedorTelefone[i].id_vendedor = this.vendedor.id;
          try {
            var ret = await this.$store.dispatch(
              "vendedorTelefone/postVendedorTelefone",
              this.vendedor.VendedorTelefone[i]
            );
            if (ret.Success === true) {
              this.vendedor.VendedorTelefone[i].id = ret.Data.id;
            }
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJson(error)
            );
            this.errosGerais = error;
            this.errosValidacaoTelefone[i] = error;
            this.confirmouCadastro = false;
          }
        } else {
          try {
            await this.$store.dispatch(
              "vendedorTelefone/putVendedorTelefone",
              this.vendedor.VendedorTelefone[i]
            );
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJson(error)
            );
            this.errosGerais = error;
            this.errosValidacaoTelefone[i] = error;
            this.confirmouCadastro = false;
          }
        }
      }
    },
    async confirmarEmail() {
      this.errosValidacaoEmail = new Array(this.vendedor.VendedorEmail.length);
      for (var i = 0; i < this.vendedor.VendedorEmail.length; i++) {
        if (this.vendedor.VendedorEmail[i].id === 0) {
          this.vendedor.VendedorEmail[i].id_vendedor = this.vendedor.id;
          try {
            var ret = await this.$store.dispatch(
              "vendedorEmail/postVendedorEmail",
              this.vendedor.VendedorEmail[i]
            );
            if (ret.Success === true) {
              this.vendedor.VendedorEmail[i].id = ret.Data.id;
            }
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJson(error)
            );
            this.errosGerais = error;
            this.errosValidacaoEmail[i] = error;
            this.confirmouCadastro = false;
          }
        } else {
          try {
            await this.$store.dispatch(
              "vendedorEmail/putVendedorEmail",
              this.vendedor.VendedorEmail[i]
            );
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJson(error)
            );
            this.errosGerais = error;
            this.errosValidacaoEmail[i] = error;
            this.confirmouCadastro = false;
          }
        }
      }
    },
    async confirmarRegraComissao() {
      for (var i = 0; i < this.vendedor.RegraComissaoVendedor.length; i++) {
        if (this.vendedor.RegraComissaoVendedor[i].id === 0) {
          this.vendedor.RegraComissaoVendedor[i].id_vendedor = this.vendedor.id;
          try {
            var ret = await this.$store.dispatch(
              "regraComissaoVendedor/postRegraComissaoVendedor",
              this.vendedor.RegraComissaoVendedor[i]
            );
            if (ret.Success === true) {
              this.vendedor.RegraComissaoVendedor[i].id = ret.Data.id;
            }
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJson(error)
            );
            this.errosGerais = error;
            this.confirmouCadastro = false;
          }
        } else {
          try {
            await this.$store.dispatch(
              "regraComissaoVendedor/putRegraComissaoVendedor",
              this.vendedor.RegraComissaoVendedor[i]
            );
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJson(error)
            );
            this.errosGerais = error;
            this.confirmouCadastro = false;
          }
        }
      }
    },
    adicionarEmail() {
      this.vendedor.VendedorEmail.push({
        id: 0,
        id_vendedor: 0,
        descricao: "Pessoal",
        email: "",
      });
    },
    async excluirEmail(index) {
      if (this.vendedor.VendedorEmail.length > 1) {
        await this.$swal.showQuestionAlert(
          "Deseja remover o registro?",
          async (alert) => {
            if (alert.isConfirmed) {
              this.errosGeraisEmail = {};
              this.errosValidacaoEmail = [];
              this.loading = true;

              var id = this.vendedor.VendedorEmail[index].id;
              if (id === 0) {
                this.vendedor.VendedorEmail.splice(index, 1);
                toast.success("Email excluído com sucesso!", { timeout: 3000 });
              } else {
                try {
                  var ret = await this.$store.dispatch(
                    "vendedorEmail/deleteVendedorEmail",
                    id
                  );
                  if (ret.Success === true) {
                    this.vendedor.VendedorEmail.splice(index, 1);
                    toast.success("Email excluído com sucesso!", {
                      timeout: 3000,
                    });
                  }
                } catch (error) {
                  this.errosGeraisEmail = error;
                  this.scroll("vendedor_email");
                }
              }
              this.loading = false;
            }
          }
        );
      }
    },
    adicionarTelefone() {
      this.vendedor.VendedorTelefone.push({
        id: 0,
        id_vendedor: 0,
        descricao: "Celular",
        telefone: "",
      });
    },
    async excluirTelefone(index) {
      if (this.vendedor.VendedorTelefone.length > 1) {
        await this.$swal.showQuestionAlert(
          "Deseja remover o registro?",
          async (alert) => {
            if (alert.isConfirmed) {
              this.errosGeraisTelefone = {};
              this.errosValidacaoTelefone = [];
              this.loading = true;

              var id = this.vendedor.VendedorTelefone[index].id;
              if (id === 0) {
                this.vendedor.VendedorTelefone.splice(index, 1);
                toast.success("Telefone excluído com sucesso!", {
                  timeout: 3000,
                });
              } else {
                try {
                  var ret = await this.$store.dispatch(
                    "vendedorTelefone/deleteVendedorTelefone",
                    id
                  );
                  if (ret.Success === true) {
                    this.vendedor.VendedorTelefone.splice(index, 1);
                    toast.success("Telefone excluído com sucesso!", {
                      timeout: 3000,
                    });
                  }
                } catch (error) {
                  this.errosGeraisTelefone = error;
                  this.scroll("vendedor_telefone");
                }
              }
              this.loading = false;
            }
          }
        );
      }
    },
    adicionarEndereco() {
      this.vendedor.VendedorEndereco.push({
        id: 0,
        id_vendedor: 0,
        descricao: "Casa",
        endereco: "",
        complemento: "",
        bairro: "",
        numero: "",
        cep: "",
        cidade: "",
        cod_cidade: "",
        uf: "SP",
        pais: "",
        cod_pais: "",
        latitude: "",
        longitude: "",
      });
    },
    async excluirEndereco(index) {
      if (this.vendedor.VendedorEndereco.length > 1) {
        await this.$swal.showQuestionAlert(
          "Deseja remover o registro?",
          async (alert) => {
            if (alert.isConfirmed) {
              this.errosGeraisEndereco = {};
              this.errosValidacaoEndereco = [];
              this.loading = true;

              var id = this.vendedor.VendedorEndereco[index].id;
              if (id === 0) {
                this.vendedor.VendedorEndereco.splice(index, 1);
                toast.success("Endereço excluído com sucesso!", {
                  timeout: 3000,
                });
              } else {
                try {
                  var ret = await this.$store.dispatch(
                    "vendedorEndereco/deleteVendedorEndereco",
                    id
                  );
                  if (ret.Success === true) {
                    this.vendedor.VendedorEndereco.splice(index, 1);
                    toast.success("Endereço excluído com sucesso!", {
                      timeout: 3000,
                    });
                  }
                } catch (error) {
                  this.errosGeraisEndereco = error;
                  this.scroll("vendedor_endereco");
                }
              }
              this.loading = false;
            }
          }
        );
      }
    },
    modalCidades(exibir) {
      this.exibirCidades = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_cidades",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarCidades");
          },
          /*close*/ () => {
            this.modalCidades(false);
          }
        );
      }
    },
    exibirModalCidades(exibir, index) {
      this.pesquisaCidadeIndex = index;
      this.modalCidades(exibir);
    },
    confirmarCidade(cidade) {
      this.vendedor.VendedorEndereco[this.pesquisaCidadeIndex].cidade =
        cidade.cidade;
      this.vendedor.VendedorEndereco[this.pesquisaCidadeIndex].cod_cidade =
        cidade.codcidade;
      this.vendedor.VendedorEndereco[this.pesquisaCidadeIndex].uf = cidade.uf;
      this.vendedor.VendedorEndereco[this.pesquisaCidadeIndex].cod_pais =
        "1058";
      this.vendedor.VendedorEndereco[this.pesquisaCidadeIndex].pais = "BRASIL";
    },
    modalPaises(exibir) {
      this.exibirPaises = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_paises",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarPaises");
          },
          /*close*/ () => {
            this.modalPaises(false);
          }
        );
      }
    },
    exibirModalPaises(exibir, index) {
      this.pesquisaPaisIndex = index;
      this.modalPaises(exibir);
    },
    confirmarPais(pais) {
      this.vendedor.VendedorEndereco[this.pesquisaPaisIndex].cod_pais =
        pais.codbacen;
      this.vendedor.VendedorEndereco[this.pesquisaPaisIndex].pais =
        pais.descricao;
    },
    async pesquisarCep(i) {
      this.loadingCep = true;
      if (
        this.vendedor.VendedorEndereco[i].cep !== null &&
        this.vendedor.VendedorEndereco[i].cep != ""
      ) {
        try {
          var ret = await this.$store.dispatch(
            "cep/getCep",
            this.vendedor.VendedorEndereco[i].cep
          );
          if (ret.Data !== null) {
            this.vendedor.VendedorEndereco[i].endereco = ret.Data.logradouro;
            this.vendedor.VendedorEndereco[i].bairro = ret.Data.bairro;
            this.vendedor.VendedorEndereco[i].complemento =
              ret.Data.complemento;
            this.vendedor.VendedorEndereco[i].cod_cidade = ret.Data.ibge;
            this.vendedor.VendedorEndereco[i].cidade = ret.Data.localidade
              ? ret.Data.localidade.toUpperCase()
              : "";
            this.vendedor.VendedorEndereco[i].uf = ret.Data.uf;
            this.vendedor.VendedorEndereco[i].pais = "BRASIL";
            this.vendedor.VendedorEndereco[i].cod_pais = "1058";
          }
        } catch (error) {
          await this.$swal.showInvalidAlert(
            "Não foi possível localizar o CEP!"
          );
        }
      }
      this.loadingCep = false;
    },
    removerFoto() {
      if (this.add === true) {
        this.vendedor.fotoRemover = "";
      } else {
        this.vendedor.fotoRemover = this.vendedor.foto.replace(
          this.$utils.getUrl(),
          ""
        );
      }
      this.vendedor.foto = "";
      this.vendedor.formFile = null;
      this.$refs.fileInput.value = null;
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          if (this.vendedor.foto !== null) {
            this.vendedor.fotoRemover = this.vendedor.foto.replace(
              this.$utils.getUrl(),
              ""
            );
          }

          this.vendedor.foto = e.target.result;
          this.vendedor.formFile = file[0];
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
    async limparVendedor() {
      this.vendedor = {
        id: 0,
        nome: "",
        fantasia: "",
        cpf_cnpj: "",
        rg_ie: "",
        ativo: "1",
        comissao_sobre: "0",
        recebimento_comissao: "0",
        comissao: 0,
        foto: "",
        dia_acerto: 1,
        nome_banco: "",
        banco: "",
        conta: "",
        dv_conta: "",
        agencia: "",
        dv_agencia: "",
        favorecido: "",
        per_desconto: 0,
        id_conta: null,
        id_custo: null,
        observacoes: "",
        percentual_adiantamento: 0,
        guid: "",
        formFile: null,
        fotoRemover: "",
        VendedorEndereco: [
          {
            id: 0,
            id_vendedor: 0,
            descricao: "Casa",
            endereco: "",
            complemento: "",
            bairro: "",
            numero: "",
            cep: "",
            cidade: "",
            cod_cidade: "",
            uf: "SP",
            pais: "",
            cod_pais: "",
            latitude: "",
            longitude: "",
          },
        ],
        VendedorTelefone: [
          {
            id: 0,
            id_vendedor: 0,
            descricao: "Celular",
            telefone: "",
          },
        ],
        VendedorEmail: [
          {
            id: 0,
            id_vendedor: 0,
            descricao: "Pessoal",
            email: "",
          },
        ],
        RegraComissaoVendedor: [],
      };

      this.errosGerais = {};
      this.errosValidacao = [];
      this.errosValidacaoGeral = [];
      this.errosGeraisTelefone = {};
      this.errosValidacaoTelefone = [];
      this.errosGeraisEndereco = {};
      this.errosValidacaoEndereco = [];
      this.errosGeraisEmail = {};
      this.errosValidacaoEmail = [];
    },
    async carregarVendedor() {
      var id = 0;
      if (this.modal === true) {
        id = this.idVendedor;
      } else {
        id = this.$route.params.id;
      }
      try {
        var ret = await this.$store.dispatch("vendedor/getVendedor", id);
        if (ret.Success === true) {
          this.vendedor = ret.Data;

          if (this.vendedor.foto !== null && this.vendedor.foto !== "") {
            this.vendedor.foto = this.$utils.getUrl() + this.vendedor.foto;
          }

          setTimeout(MenuComponent.reinitialization, 500);
        }
      } catch (error) {
        this.errosGerais = error;
      }
      this.loading = false;
    },
    async asyncData() {
      if (
        (this.$route.name.includes("cadastros/vendedores/editar") &&
          this.$route.params.id !== undefined) ||
        this.idVendedor !== 0
      ) {
        this.loading = true;
        this.add = false;
        await this.carregarVendedor();
      } else {
        this.add = true;
        await this.limparVendedor();
      }

      this.pesquisaCidadeIndex = 0;
      this.pesquisaPaisIndex = 0;
      this.confirmouCadastro = true;
    },
    scroll(refName) {
      let el = this.$refs[refName];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.VendedorTelefone.Consultar") {
            this.consultarVendedorTelefone = true;
          }
          if (element.regra === "Permitir.VendedorTelefone.Incluir") {
            this.adicionarVendedorTelefone = true;
          }
          if (element.regra === "Permitir.VendedorTelefone.Alterar") {
            this.editarVendedorTelefone = true;
          }
          if (element.regra === "Permitir.VendedorTelefone.Excluir") {
            this.excluirVendedorTelefone = true;
          }

          if (element.regra === "Permitir.VendedorEndereco.Consultar") {
            this.consultarVendedorEndereco = true;
          }
          if (element.regra === "Permitir.VendedorEndereco.Incluir") {
            this.adicionarVendedorEndereco = true;
          }
          if (element.regra === "Permitir.VendedorEndereco.Alterar") {
            this.editarVendedorEndereco = true;
          }
          if (element.regra === "Permitir.VendedorEndereco.Excluir") {
            this.excluirVendedorEndereco = true;
          }

          if (element.regra === "Permitir.VendedorEmail.Consultar") {
            this.consultarVendedorEmail = true;
          }
          if (element.regra === "Permitir.VendedorEmail.Incluir") {
            this.adicionarVendedorEmail = true;
          }
          if (element.regra === "Permitir.VendedorEmail.Alterar") {
            this.editarVendedorEmail = true;
          }
          if (element.regra === "Permitir.VendedorEmail.Excluir") {
            this.excluirVendedorEmail = true;
          }
        });
      }
    },
    async pesquisarCNPJ() {
      this.loadingCNPJ = true;
      if (
        this.vendedor.cpf_cnpj &&
        this.vendedor.cpf_cnpj !== null &&
        this.vendedor.cpf_cnpj != ""
      ) {
        try {
          if (this.$utils.validarCPFCNPJ(this.vendedor.cpf_cnpj)) {
            if (this.vendedor.cpf_cnpj.replace(/[^\d]/g, "").length === 14) {
              var ret = await this.$utils.consultarCNPJ(this.vendedor.cpf_cnpj);
              if (ret.data) {
                const dadosCNPJ = ret.data;
                this.vendedor.nome = dadosCNPJ.razao_social;
                this.vendedor.fantasia =
                  dadosCNPJ.estabelecimento.nome_fantasia;
                this.vendedor.VendedorEndereco[0].endereco =
                  dadosCNPJ.estabelecimento.logradouro;
                this.vendedor.VendedorEndereco[0].complemento =
                  dadosCNPJ.estabelecimento.complemento;
                this.vendedor.VendedorEndereco[0].bairro =
                  dadosCNPJ.estabelecimento.bairro;
                this.vendedor.VendedorEndereco[0].numero =
                  dadosCNPJ.estabelecimento.numero;
                this.vendedor.VendedorEndereco[0].cep =
                  dadosCNPJ.estabelecimento.cep;
                this.vendedor.VendedorEndereco[0].cidade =
                  dadosCNPJ.estabelecimento.cidade.nome;
                this.vendedor.VendedorEndereco[0].cod_cidade =
                  dadosCNPJ.estabelecimento.cidade.ibge_id.toString();
                this.vendedor.VendedorEndereco[0].uf =
                  dadosCNPJ.estabelecimento.estado.sigla;
                this.vendedor.VendedorEndereco[0].cod_uf =
                  dadosCNPJ.estabelecimento.estado.id;
                this.vendedor.VendedorEndereco[0].pais =
                  dadosCNPJ.estabelecimento.pais.nome;
                this.vendedor.VendedorEndereco[0].cod_pais =
                  dadosCNPJ.estabelecimento.pais.id;
                this.vendedor.email = dadosCNPJ.estabelecimento.email;
                this.vendedor.pais = dadosCNPJ.estabelecimento.pais.nome;
                if (
                  dadosCNPJ.estabelecimento.inscricoes_estaduais &&
                  dadosCNPJ.estabelecimento.inscricoes_estaduais.length > 0
                ) {
                  this.vendedor.rg_ie =
                    dadosCNPJ.estabelecimento.inscricoes_estaduais[0].inscricao_estadual;
                }
                this.vendedor.fisica = "J";
              }
            } else {
              await this.$swal.showInvalidAlert(
                "A consulta é destinada apenas para CNPJ!\r\n\r\nPara pessoa física, informe os dados manualmente."
              );
            }
          } else {
            await this.$swal.showInvalidAlert("O CNPJ informado é inválido!");
          }
        } catch (error) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.detalhes
          ) {
            await this.$swal.showInvalidAlert(error.response.data.detalhes);
          } else {
            await this.$swal.showInvalidAlert(
              "Não foi possível localizar o CNPJ informado!"
            );
          }
        }
      }
      this.loadingCNPJ = false;
    },
  },
  watch: {
    $route: {
      handler: "asyncData",
      immediate: true,
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    this.asyncData();
  },
  data() {
    return {
      consultarVendedorTelefone: false,
      adicionarVendedorTelefone: false,
      editarVendedorTelefone: false,
      excluirVendedorTelefone: false,
      consultarVendedorEndereco: false,
      adicionarVendedorEndereco: false,
      editarVendedorEndereco: false,
      excluirVendedorEndereco: false,
      consultarVendedorEmail: false,
      adicionarVendedorEmail: false,
      editarVendedorEmail: false,
      excluirVendedorEmail: false,
      exibirEditarRegraComissaoVendedor: false,
      exibirCustos: false,
      exibirContas: false,
      confirmouCadastro: true,
      loading: false,
      loadingCep: false,
      loadingRegraComissao: false,
      add: false,
      pesquisaCidadeIndex: 0,
      pesquisaPaisIndex: 0,
      errosGerais: {},
      errosValidacao: [],
      errosValidacaoGeral: [],
      errosGeraisTelefone: {},
      errosValidacaoTelefone: [],
      errosGeraisEndereco: {},
      errosValidacaoEndereco: [],
      errosGeraisEmail: {},
      errosValidacaoEmail: [],
      exibirCidades: false,
      cidadeSelecionada: null,
      exibirPaises: false,
      paisSelecionado: null,
      loadingCNPJ: false,
      consultaCep: {
        cep: "",
        endereco: "",
        bairro: "",
        complemento: "",
        cod_cidade: "",
        cidade: "",
        uf: "SP",
        pais: "",
        cod_pais: "",
      },
      vendedor: {
        id: 0,
        nome: "",
        fantasia: "",
        cpf_cnpj: "",
        rg_ie: "",
        ativo: "1",
        comissao_sobre: "0",
        recebimento_comissao: "0",
        comissao: 0,
        foto: "",
        dia_acerto: 1,
        nome_banco: "",
        banco: "",
        conta: "",
        dv_conta: "",
        agencia: "",
        dv_agencia: "",
        favorecido: "",
        per_desconto: 0,
        id_conta: null,
        id_custo: null,
        observacoes: "",
        percentual_adiantamento: 0,
        guid: "",
        formFile: null,
        fotoRemover: "",
        VendedorEndereco: [
          {
            id: 0,
            id_vendedor: 0,
            descricao: "Casa",
            endereco: "",
            complemento: "",
            bairro: "",
            numero: "",
            cep: "",
            cidade: "",
            cod_cidade: "",
            uf: "SP",
            pais: "",
            cod_pais: "",
            latitude: "",
            longitude: "",
          },
        ],
        VendedorTelefone: [
          {
            id: 0,
            id_vendedor: 0,
            descricao: "Celular",
            telefone: "",
          },
        ],
        VendedorEmail: [
          {
            id: 0,
            id_vendedor: 0,
            descricao: "Pessoal",
            email: "",
          },
        ],
        RegraComissaoVendedor: [],
      },
      regraComissao: {
        index: -1,
        id: 0,
        id_vendedor: 0,
        valor_venda: 0,
        per_comissao: 0,
      },
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
      tableRegraComissaoVendedorHeader: [
        {
          name: "Valor acima de",
          key: "valor_venda",
          sortable: true,
        },
        {
          name: "% Comissão",
          key: "per_comissao",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
    };
  },
};
</script>

<style>
.imagePreviewWrapper {
  background-size: contain !important;
  background-position: center !important;
}
</style>
